import * as React from "react";
import { SiegeLieuSuiviFichierApi, SiegeLieuSuiviFichierDto } from "../../../../../../api";
import { useApiService, useCrudApi, useTl } from "../../../../../../hooks";
import { ETLCodes } from "../../../../../../locales";
import * as Yup from "yup";
import { useReferential } from "../../../../../../hooks/useReferential";
import styled from "styled-components";
import { Classes, Dialog } from "@blueprintjs/core";
import { FGWalterSelectInput, SmallFormGenerator } from "../../../../../../components";
import { FGTextInput, FieldGroup } from "nsitools-react";

const StyledDialog = styled(Dialog)`
  width: 600px;
  height: auto;
  background-color: white;
`;

export interface ISiegeLieuSuiviDocumentEditDialogProps {
  idsiegeLieuSuiviFichier: number;
  onClose: (refresh?: boolean) => void;
}

export const SiegeLieuSuiviDocumentEditDialog: React.FunctionComponent<ISiegeLieuSuiviDocumentEditDialogProps> = ({
  idsiegeLieuSuiviFichier,
  onClose
}) => {
  const { t } = useTl();
  const api = useApiService(SiegeLieuSuiviFichierApi);

  const { data, loading, saveItem, saving, validationErrors } = useCrudApi(
    React.useMemo(
      () => ({
        getApiFn: () => {
          return api.siegeLieuSuiviFichierGetSuiviFichier({
            id: idsiegeLieuSuiviFichier
          });
        },
        saveApiFn: async (d: SiegeLieuSuiviFichierDto) => {
          return api.siegeLieuSuiviFichierSaveSuiviFichier({
            SiegeLieuSuiviFichierDto: d
          });
        },
        onSaved: () => onClose(true)
      }),
      [api, idsiegeLieuSuiviFichier, onClose]
    )
  );

  const FormSchema = React.useMemo(
    () =>
      Yup.object().shape({
        idtypeSuiviFichier: Yup.number().nullable()
      }),
    []
  );

  const [typesSuiviFichier, tLoading] = useReferential(a => a.referentialGetTypesSuiviFichier());

  return (
    <StyledDialog title={t(ETLCodes.UploadFichier)} isOpen={!!idsiegeLieuSuiviFichier} onClose={() => onClose(false)}>
      <div className={Classes.DIALOG_BODY}>
        <SmallFormGenerator
          initialValues={data}
          onSubmit={saveItem}
          editMode={true}
          validationSchema={FormSchema}
          onCancel={() => onClose(false)}
          showDeleteButton={false}
          saving={saving}
          loading={loading}
          validationErrors={validationErrors}
        >
          <FieldGroup>
            <FGTextInput name="fileName" label={t(ETLCodes.Fichier)} readonly />
            <FGWalterSelectInput
              name="idtypeSuiviFichier"
              label={t(ETLCodes.Type)}
              items={typesSuiviFichier}
              loading={tLoading}
            />
          </FieldGroup>
        </SmallFormGenerator>
      </div>
    </StyledDialog>
  );
};
